var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1606 6.43945H7.56057V0.839447C7.56057 0.53183 7.30901 0.2789 7.00003 0.2789C6.69241 0.2789 6.43948 0.530463 6.43948 0.839447V6.43945H0.839478C0.53186 6.43945 0.278931 6.69101 0.278931 6.99999C0.278931 7.30761 0.530493 7.56054 0.839478 7.56054H6.43948V13.1605C6.43948 13.4682 6.69104 13.7211 7.00003 13.7211C7.30764 13.7211 7.56057 13.4695 7.56057 13.1605V7.56054H13.1606C13.4682 7.56054 13.7211 7.30898 13.7211 6.99999C13.7198 6.69238 13.4682 6.43945 13.1606 6.43945Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.19c37889c5a2a5628f7aa660ed3eeb9f.svg";
export { ForwardRef as ReactComponent };